<template>
    <b-table bordered striped small hover :items="attachments" :fields="fields" v-if="(attachments != null) && (attachments.length > 0)">
        <template v-slot:cell(fileDetails.fileName)="data">
            <a :href="fileDownloadUrl.replace('00000000-0000-0000-0000-000000000000', data.item.fileId)"
               v-if="fileDownloadUrl && fileAvailable(data.item.fileDetails)">{{ data.item.fileDetails.fileName }}</a>

            <div v-if="!fileAvailable(data.item.fileDetails)">
                <ejs-tooltip position="TopRight" :content="fileUnavailableTooltip(data.item.fileDetails)" style="display: inline;">
                    <b-icon icon="info-circle-fill" variant="secondary" style="height: 15px; width: 15px; cursor: pointer; margin-right:-7px;"></b-icon>
                </ejs-tooltip>
                <span style="margin-left: 7px;">
                    {{ data.item.fileDetails.fileName }}
                </span>

            </div>

            <template v-if="!fileDownloadUrl">
                {{ data.value }}
            </template>
        </template>
    </b-table>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';

    import ErrorsMixin from '../mixins/ErrorsMixin';
    import DateTimeMixin from '../mixins/DateTimeMixin';


    Vue.use(BootstrapVue);

    export default {
        name: 'WorkitemAttachments',
        mixins: [ErrorsMixin, DateTimeMixin],
        props: {
            apiControllerUrl: {
                type: String,
                required: true
            },
            fileDownloadUrl: {
                type: String,
                default: null
            },
            workItemId: {
                type: String,
                required: true
            }
        },
        data: function () {
            return {
                attachments: null,
                fields: [
                    {
                        key: 'fileDetails.fileName',
                        label: 'File Name',
                        sortable: true
                    },
                    {
                        key: 'fileDetails.fileSize',
                        label: 'Size',
                        formatter: (value, key, item) => {
                            var strVal = '';
                            if (value > (10 * 1024 * 1024 * 1024)) {
                                strVal = Math.round(value / (1024 * 1024 * 1024)) + ' GB';
                            } else if (value > (10 * 1024 * 1024)) {
                                strVal = Math.round(value / (1024 * 1024)) + ' MB';
                            } else if (value > (10 * 1024)) {
                                strVal = Math.round(value / 1024) + ' KB';
                            } else {
                                strVal = value + ' Bytes';
                            }
                            if (item.fileDetails.uploadInProgress) {
                                strVal += ' (uploading)';
                            }
                            return strVal;
                        },
                        thStyle: { width: '200px' },
                        sortable: true
                    },
                    {
                        key: 'classificationDisplayName',
                        label: 'Classification',
                        sortable: true
                    },
                    {
                        key: 'order.orderingClient.name',
                        label: 'Ordering Client',
                        sortable: true
                    }
                ],
                currentErrors: []
            };
        },
        methods: {
            fileAvailable: function (fileDetails) {
                if (fileDetails.deletedByDataRetentionExecutionId != null || fileDetails.archivedByDataRetentionExecutionId != null)
                    return false;
                return true;
            },
            fileUnavailableTooltip: function (fileDetails) {
                var message = "";
                if (fileDetails.deletedByDataRetentionExecution != null)
                    message = "This file has been permanently deleted as per company data retention policies on the "
                        + this.formatDateTime(this.parseDateTime(fileDetails.deletedByDataRetentionExecution.completedDateTimeUTC), "DD/MM/yy")
                        + ", by rule: "
                        + fileDetails.deletedByDataRetentionExecution.dataRetentionRule.name;

                else if (fileDetails.archivedByDataRetentionExecution != null)
                    message = "This file has been archived as per company data retention policies on the "
                        + this.formatDateTime(this.parseDateTime(fileDetails.archivedByDataRetentionExecution.completedDateTimeUTC), "DD/MM/yy")
                        + ", by rule: "
                        + fileDetails.archivedByDataRetentionExecution.dataRetentionRule.name;
                else
                    message = "Error.";

                return message;
            },
            reload: function () {
                this.currentErrors = [];
                if (this.workItemId) {
                    return axios
                        .get(this.apiControllerUrl + '/byworkitem/' + this.workItemId + '/list')
                        .then(response => {
                            this.attachments = response.data;
                        })
                        .catch(ex => {
                            this.currentErrors = this.handleAxiosException(ex);
                        })
                        .finally(() => {
                            if (this.currentErrors.length != 0) {
                                this.showErrorsToast(this.currentErrors);
                            }
                        });
                }
                return Promise.resolve();
            }
        },
        mounted: function () {
            this.reload();
        }
    }
</script>